module.exports = __webpack_public_path__ + "static/img/heigit-and-hd-uni.23cf622.png";